<script>
    import { t } from '../i18n.js'
    import SwaggerUI from '../components/SwaggerUI.svelte'
    import ViewCardContainer from '../components/ViewCardContainer.svelte'
    import AlertBox from '../components/common/AlertBox.svelte'
    import { onMount } from 'svelte'
    import { startAuth } from '../login.js'
    import CopyToClipboard from '../components/common/CopyToClipboard.svelte'
    import { environment } from '../enviroments/enviroment.js'    

    let isLoggedIn
    let accessToken
    let refreshToken
    let userGroups
    let permissions = []
    onMount(() => {
		isLoggedIn = localStorage.getItem('isLoggedIn')
		accessToken = localStorage.getItem('accessToken')
        refreshToken = localStorage.getItem('refreshToken')

        userGroups = JSON.parse(localStorage.getItem('userGroups')) 
        if(userGroups) {
            for (let permission of userGroups.active) {
                permissions.push(permission.permissionExternalId)
            }
        }
    })

    const envName = environment.envName
    const useCase = window.location.href.substring(window.location.href.lastIndexOf('/')+1)
    const apiDoc = `${envName}-import-api${useCase}-doc.yml`

    const checkIfHasAccess = () => {
        let pattern = /^vmq.*$/
        return permissions.some(e => pattern.test(e))
    }

    onMount(() => {
		window.scrollTo(0,0)
	})

    export let name = `dataimport.api${useCase}-name`


</script>
<ViewCardContainer pageTitle={$t(name)}>
    {#if !isLoggedIn}
        <div class="mb-8">
            <AlertBox>
                <p>{$t('datasource.token-notice')}<button on:click={startAuth} class="text-navy font-semibold">{$t('datasource.token-notice-link')}</button></p>
            </AlertBox>
        </div>
    {/if}
    <h2 class="mb-2">{$t('datasource.page-title')}</h2>
    <p class="mb-12">{$t('datasource.page-description')}</p>
        {#if isLoggedIn && checkIfHasAccess()}
            <h3 class="mb-2">{$t('datasource.token-title')}</h3>
            <p class="mb-2" style="font-style: italic;">{$t('datasource.token-lifetime')}</p>
            <CopyToClipboard content={accessToken} componentId={'access'}/>
            <h3 class="mb-2">{$t('datasource.refresh-token-title')}</h3>
            <p class="mb-2" style="font-style: italic;">{$t('datasource.refresh-token-lifetime')}</p>
            <CopyToClipboard content={refreshToken} componentId={'refresh'} />
            {:else}
                {#if isLoggedIn && !checkIfHasAccess()}
                    <!-- HUOM. Voisi tehdä jossain CSS-luokassa. Quick fix -->
                    <h2 class="mb-8" style="color: crimson; font-size: larger">{$t('datasource.permission-not-found')}</h2>
                {/if}
        {/if}
        <h2>{$t('datasource.api-description')}</h2>
        <SwaggerUI doc={apiDoc} />
    
</ViewCardContainer>